import { populate } from "populate";

const raw = {
  width: 1350,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: "224789f4-b13e-4776-937b-4619475857e2",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "7b41899f-9348-48b6-a2c3-24f1985c0f3b",
      type: "Container",
      name: "petContainer",
      nameSpace: "",
      className: "",
      x: 218,
      y: 762,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "224789f4-b13e-4776-937b-4619475857e2",
      data: ""
    },
    {
      id: "6531b7c6-ef1e-4e7f-9e16-0c52c07a3a5a",
      type: "Container",
      name: "",
      nameSpace: "foodContainer",
      className: "",
      x: 675,
      y: 380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "224789f4-b13e-4776-937b-4619475857e2",
      data: ""
    },
    {
      id: "d0077cd7-2b7f-49d2-80d9-d309cc860531",
      type: "Text",
      name: "",
      nameSpace: "",
      className: "",
      x: 675,
      y: 150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "PickOneToFeed",
      localize: true,
      maxWidth: 1000,
      maxHeight: 80,
      maxFontSize: 42,
      icons: [],
      style: {
        fontSize: 42,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "black",
        strokeThickness: 8,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "224789f4-b13e-4776-937b-4619475857e2",
      data: ""
    },
    {
      id: "5df9f865-02ed-46e8-b91a-d5e9dc1de40c",
      type: "Text",
      name: "continueText",
      nameSpace: "",
      className: "",
      x: 675,
      y: 730,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "ClickToContinue",
      localize: true,
      maxWidth: 600,
      maxHeight: 60,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "white",
        stroke: "black",
        strokeThickness: 8,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "224789f4-b13e-4776-937b-4619475857e2",
      data: ""
    },
    {
      id: "25c571ea-f840-4720-a8a6-29be6ee741f8",
      type: "Container",
      name: "food_0",
      nameSpace: "food[]",
      className: "",
      x: -320,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      parent: "6531b7c6-ef1e-4e7f-9e16-0c52c07a3a5a",
      data: ""
    },
    {
      id: "a2df4ef7-565e-491f-a474-e3e493304dfe",
      type: "Container",
      name: "food_1",
      nameSpace: "food[]",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      parent: "6531b7c6-ef1e-4e7f-9e16-0c52c07a3a5a",
      data: ""
    },
    {
      id: "e5d284aa-bae2-4c4d-8bea-be9dc33a8960",
      type: "Container",
      name: "food_2",
      nameSpace: "food[]",
      className: "",
      x: 320,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: "None"
      },
      parent: "6531b7c6-ef1e-4e7f-9e16-0c52c07a3a5a",
      data: ""
    },
    {
      id: "7ebb2915-f47b-46d0-9cc1-ea9ec9aef350",
      type: "Container",
      name: "spritesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "25c571ea-f840-4720-a8a6-29be6ee741f8",
      data: ""
    },
    {
      id: "b7c3ac1f-f6e5-495c-942c-1050172f6408",
      type: "Container",
      name: "rewardContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "25c571ea-f840-4720-a8a6-29be6ee741f8",
      data: ""
    },
    {
      id: "95db531f-e9aa-4c44-a6ec-48a8d5160fa0",
      type: "Container",
      name: "spritesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "a2df4ef7-565e-491f-a474-e3e493304dfe",
      data: ""
    },
    {
      id: "6cffdf4d-16b4-41f3-aa75-2777e1ccfe44",
      type: "Container",
      name: "rewardContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "a2df4ef7-565e-491f-a474-e3e493304dfe",
      data: ""
    },
    {
      id: "27ff6a02-a018-4466-b7bc-f78d7f629293",
      type: "Container",
      name: "spritesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "e5d284aa-bae2-4c4d-8bea-be9dc33a8960",
      data: ""
    },
    {
      id: "c0993635-1d2f-4b75-940d-2c6722d1931d",
      type: "Container",
      name: "rewardContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "e5d284aa-bae2-4c4d-8bea-be9dc33a8960",
      data: ""
    },
    {
      id: "516465d9-8130-4ff3-95fa-98d3760e2b4b",
      type: "Sprite",
      name: "selectorSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_map_slot",
      parent: "7ebb2915-f47b-46d0-9cc1-ea9ec9aef350",
      data: ""
    },
    {
      id: "a506b77e-5890-41f4-b401-8c29f510e3d6",
      type: "Sprite",
      name: "foodSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "pet_minigame_feed_1",
      parent: "7ebb2915-f47b-46d0-9cc1-ea9ec9aef350",
      data: ""
    },
    {
      id: "8ec203b0-f9c4-4779-b3fa-258641644399",
      type: "Sprite",
      name: "checkSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 125,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_check",
      parent: "7ebb2915-f47b-46d0-9cc1-ea9ec9aef350",
      data: ""
    },
    {
      id: "467d6e35-9602-4720-998c-d92900e3e160",
      type: "Container",
      name: "DBContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "b7c3ac1f-f6e5-495c-942c-1050172f6408",
      data: ""
    },
    {
      id: "616620ad-5df8-4855-84c3-a82c2c8b3031",
      type: "Sprite",
      name: "rewardSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_large",
      parent: "b7c3ac1f-f6e5-495c-942c-1050172f6408",
      data: ""
    },
    {
      id: "acf2742d-9a51-4105-affb-0b58ba774aaf",
      type: "Text",
      name: "rewardText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 146,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "+ 500 coins!",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFD11B",
        stroke: "black",
        strokeThickness: 6,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "b7c3ac1f-f6e5-495c-942c-1050172f6408",
      data: ""
    },
    {
      id: "873d6aed-1f00-49a4-8957-6f9cbb8094df",
      type: "Sprite",
      name: "selectorSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_map_slot",
      parent: "95db531f-e9aa-4c44-a6ec-48a8d5160fa0",
      data: ""
    },
    {
      id: "36ce8b06-c584-4f19-a42e-0b3aadaa0aa5",
      type: "Sprite",
      name: "foodSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "pet_minigame_feed_2",
      parent: "95db531f-e9aa-4c44-a6ec-48a8d5160fa0",
      data: ""
    },
    {
      id: "1a1107fb-85c3-480e-8750-682564cb397c",
      type: "Sprite",
      name: "checkSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 125,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_check",
      parent: "95db531f-e9aa-4c44-a6ec-48a8d5160fa0",
      data: ""
    },
    {
      id: "64ae0dc6-206e-4f17-af16-7505b66347ed",
      type: "Container",
      name: "DBContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "6cffdf4d-16b4-41f3-aa75-2777e1ccfe44",
      data: ""
    },
    {
      id: "4d95f466-1241-4035-b367-a8f17f86212e",
      type: "Sprite",
      name: "rewardSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_large",
      parent: "6cffdf4d-16b4-41f3-aa75-2777e1ccfe44",
      data: ""
    },
    {
      id: "564a7b27-833d-4aa0-afda-ebe5907eab86",
      type: "Text",
      name: "rewardText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 146,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "+ 500 coins!",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFD11B",
        stroke: "black",
        strokeThickness: 6,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "6cffdf4d-16b4-41f3-aa75-2777e1ccfe44",
      data: ""
    },
    {
      id: "287be3d3-0159-4cde-949d-53bd6d0cf7cc",
      type: "Sprite",
      name: "selectorSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_map_slot",
      parent: "27ff6a02-a018-4466-b7bc-f78d7f629293",
      data: ""
    },
    {
      id: "20dd4daa-3b67-4357-a037-27b3f19c2f64",
      type: "Sprite",
      name: "foodSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "pet_minigame_feed_3",
      parent: "27ff6a02-a018-4466-b7bc-f78d7f629293",
      data: ""
    },
    {
      id: "e338e101-c81a-4ba5-914a-5fdb6b81710c",
      type: "Sprite",
      name: "checkSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 125,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "Pet_Minigame_check",
      parent: "27ff6a02-a018-4466-b7bc-f78d7f629293",
      data: ""
    },
    {
      id: "ae25a797-8c1d-4ff2-93c6-333648419592",
      type: "Container",
      name: "DBContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "c0993635-1d2f-4b75-940d-2c6722d1931d",
      data: ""
    },
    {
      id: "2edc2777-c5b8-42ca-815a-33d59209bdec",
      type: "Sprite",
      name: "rewardSprite",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "coin_large",
      parent: "c0993635-1d2f-4b75-940d-2c6722d1931d",
      data: ""
    },
    {
      id: "c49a1d10-00f2-4fd9-b2b4-43e5a47ea031",
      type: "Text",
      name: "rewardText",
      nameSpace: "",
      className: "",
      x: 0,
      y: 146,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      text: "+ 500 coins!",
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: "normal",
        fontFamily: "FrancoisOne",
        fill: "#FFD11B",
        stroke: "black",
        strokeThickness: 6,
        align: "center",
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: "normal",
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: "black",
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: "round",
        miterLimit: 10,
        trim: false,
        textBaseline: "alphabetic",
        whiteSpace: "pre",
        fontVariant: "normal",
        letterSpacing: 0
      },
      parent: "c0993635-1d2f-4b75-940d-2c6722d1931d",
      data: ""
    }
  ]
} as const;

export class FarmMiniGameLayout {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  petContainer: GameObject<PIXI.Container>;
  continueText: GameObject<PIXI.Text>;
  foodContainer: {
    food_0: GameObject<PIXI.Container>
    food_1: GameObject<PIXI.Container>
    food_2: GameObject<PIXI.Container>
    food: ({
      spritesContainer: GameObject<PIXI.Container>
      selectorSprite: GameObject<PIXI.Sprite>
      foodSprite: GameObject<PIXI.Sprite>
      checkSprite: GameObject<PIXI.Sprite>
      rewardContainer: GameObject<PIXI.Container>
      DBContainer: GameObject<PIXI.Container>
      rewardSprite: GameObject<PIXI.Sprite>
      rewardText: GameObject<PIXI.Text>
      children: (GameObject<PIXI.Container>)[]
    })[]
    children: (GameObject<PIXI.Container>)[]
  };

  constructor() {
    populate(this, raw);
  }
}
